// config/api.js
import ENV_CONFIG from './environment';

const API_CONFIG = {
  // Use centralized environment configuration
  BASE_URL: ENV_CONFIG.getApiUrl(),
  
  ENDPOINTS: {
    TOKEN: '/token/',
    TOKEN_REFRESH: '/token/refresh/',
    CURRENT_USER: '/me/',
    USERS: '/users/',
    TASKS: '/tasks/',
    WORKSPACES: '/workspaces/',

    CHATS: '/chats/',
    CHAT_MESSAGES: '/chats/{chatId}/messages/',
    MESSAGES: '/messages/',
  },
};

export default API_CONFIG;